module.exports = __webpack_public_path__ + "static/Robinhood-20918d2eb28951ff97306c45465f8700.jpg";